/**
 * Safe wrappers around Intl / toLocaleString to defend against rare
 * `RangeError: Internal error. Icu error.` (Chrome/Safari ICU glitches)
 * and `RangeError: Invalid time value` from malformed dates.
 */

export function safeFormatNumber(
  value: number | null | undefined,
  options?: Intl.NumberFormatOptions,
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "0";
  try {
    return value.toLocaleString("en-US", options);
  } catch {
    // ICU error or unsupported options — fall back to plain string
    try {
      return String(Math.round(value));
    } catch {
      return "0";
    }
  }
}
